import React from 'react'
import { Link } from 'react-router-dom'
import features01 from '../../assets/img/features/about-img4.png'

function Aboutarea() {
    return (
        <>
            <section className="about-area about-p pt-120 pb-120 p-relative fix">
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-lg-12">
                            <img src={features01} alt="img" />
                        </div>
                        <div className="col-lg-8">
                            <div className="section-title center-align mt-80 mb-80 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s" >
                                <h5>since from 2000</h5>
                                <h2>
                                    We combine design, development,business process and data insights to
                                    accelerate digital transformations
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row bdr">
                        <div className="col-lg-12 col-md-12 col-sm-12 wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s" >
                            <div className="about-box text-center">
                                <ul>
                                    <li>
                                        <p>suport email</p>
                                        <h4>
                                            <Link to="">info@gentech.com</Link>
                                        </h4>
                                    </li>
                                    <li>
                                        <p>phone number</p>
                                        <h4>
                                            <Link to="tel:+888 777 666 00">+888 777 666 00</Link>
                                        </h4>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12 text-center">
                            <Link to="#" className="arrow-btn">
                            <i className="fas fa-long-arrow-down faa-vertical animated"></i>
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Aboutarea